import { render, staticRenderFns } from "./govsplogin.vue?vue&type=template&id=2a87a81e&"
import script from "./govsplogin.vue?vue&type=script&lang=js&"
export * from "./govsplogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports